<div class="min-h-[85vh] flex items-center justify-center p-4 bg-[#0a0b10] relative overflow-hidden">
  
  <!-- Ambient Neon Background Glow -->
  <div class="absolute w-96 h-96 bg-purple-600/10 rounded-full blur-3xl pointer-events-none top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></div>

  <!-- Loading State -->
  <div *ngIf="loading" class="relative text-center p-8 bg-[#121422]/90 backdrop-blur-xl rounded-2xl border border-purple-500/40 shadow-[0_0_30px_rgba(168,85,247,0.15)] max-w-sm w-full">
    <!-- Glowing Pulse Spinner -->
    <div class="relative w-20 h-20 mx-auto mb-6 flex items-center justify-center">
      <div class="absolute inset-0 rounded-full border-4 border-purple-500/20 animate-ping"></div>
      <div class="w-16 h-16 rounded-full border-4 border-t-indigo-500 border-r-purple-500 border-b-pink-500 border-l-transparent animate-spin shadow-[0_0_15px_rgba(168,85,247,0.4)]"></div>
    </div>
    <p class="text-purple-300 font-bold tracking-wide text-lg animate-pulse">Processing Unsubscribe...</p>
    <p class="text-slate-400 text-xs mt-2">Updating your email preferences</p>
  </div>

  <!-- Success State -->
  <div *ngIf="!loading && status === 'success'" 
       class="relative overflow-hidden bg-[#121422]/95 backdrop-blur-xl rounded-2xl border border-purple-500/40 shadow-[0_0_40px_rgba(168,85,247,0.2)] p-8 w-full max-w-md text-center">
    <!-- Top Accent Glow -->
    <div class="absolute -top-12 left-1/2 -translate-x-1/2 w-44 h-44 bg-pink-500/15 rounded-full blur-2xl pointer-events-none"></div>

    <!-- Success Icon -->
    <div class="relative mb-6">
      <div class="w-20 h-20 mx-auto bg-gradient-to-br from-[#9B0F3B] via-purple-500 to-pink-500 rounded-full p-[2px] shadow-[0_0_20px_rgba(168,85,247,0.5)] flex items-center justify-center">
        <div class="w-full h-full bg-[#121422] rounded-full flex items-center justify-center">
          <svg class="w-10 h-10 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M3 3l18 18"></path>
          </svg>
        </div>
      </div>
    </div>

    <!-- Success Text -->
    <h1 class="text-2xl font-bold text-white mb-2 tracking-wide">
      Unsubscribed!
    </h1>
    <p class="text-slate-300 text-sm mb-1">
      You have been successfully removed from our mailing list.
    </p>
    <p class="text-slate-400 text-xs mb-6">
      You will no longer receive promotional emails from this campaign.
    </p>

    <!-- Close Button (Matched with Theme's Play Now / Claim Bonus button) -->
    <button (click)="onClose()" class="w-full py-3 px-6 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white font-semibold rounded-xl shadow-[0_0_20px_rgba(99,102,241,0.4)] hover:shadow-[0_0_25px_rgba(168,85,247,0.6)] border border-purple-400/30 transition-all duration-300 transform active:scale-95 text-sm tracking-wider">
      Close Window
    </button>
  </div>

  <!-- Already Unsubscribed State -->
  <div *ngIf="!loading && status === 'already'" 
       class="relative overflow-hidden bg-[#121422]/95 backdrop-blur-xl rounded-2xl border border-pink-500/40 shadow-[0_0_40px_rgba(236,72,153,0.2)] p-8 w-full max-w-md text-center">
    <!-- Accent Glow -->
    <div class="absolute -top-12 left-1/2 -translate-x-1/2 w-44 h-44 bg-purple-500/15 rounded-full blur-2xl pointer-events-none"></div>

    <!-- Info Icon -->
    <div class="relative mb-6">
      <div class="w-20 h-20 mx-auto bg-gradient-to-br from-purple-500 via-pink-500 to-rose-500 rounded-full p-[2px] shadow-[0_0_20px_rgba(236,72,153,0.5)] flex items-center justify-center">
        <div class="w-full h-full bg-[#121422] rounded-full flex items-center justify-center">
          <svg class="w-10 h-10 text-pink-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
      </div>
    </div>

    <!-- Message -->
    <h1 class="text-2xl font-bold text-white mb-2 tracking-wide">
      Already Unsubscribed!
    </h1>
    <p class="text-slate-300 text-sm mb-1">
      This email is already unsubscribed from our list.
    </p>
    <p class="text-slate-400 text-xs mb-6">
      No further action is required.
    </p>

    <!-- Close Button -->
    <button (click)="onClose()" class="w-full py-3 px-6 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white font-semibold rounded-xl shadow-[0_0_20px_rgba(99,102,241,0.4)] hover:shadow-[0_0_25px_rgba(168,85,247,0.6)] border border-purple-400/30 transition-all duration-300 transform active:scale-95 text-sm tracking-wider">
      Close Window
    </button>
  </div>

  <!-- Error State -->
  <div *ngIf="!loading && status === 'error'" 
       class="relative overflow-hidden bg-[#121422]/95 backdrop-blur-xl rounded-2xl border border-rose-500/40 shadow-[0_0_40px_rgba(244,63,94,0.2)] p-8 w-full max-w-md text-center">
    <!-- Red Accent Glow -->
    <div class="absolute -top-12 left-1/2 -translate-x-1/2 w-44 h-44 bg-rose-500/15 rounded-full blur-2xl pointer-events-none"></div>

    <!-- Error Icon -->
    <div class="relative mb-6">
      <div class="w-20 h-20 mx-auto bg-gradient-to-br from-rose-500 to-pink-600 rounded-full p-[2px] shadow-[0_0_20px_rgba(244,63,94,0.5)] flex items-center justify-center">
        <div class="w-full h-full bg-[#121422] rounded-full flex items-center justify-center">
          <svg class="w-10 h-10 text-rose-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </div>
      </div>
    </div>

    <!-- Error Message -->
    <h1 class="text-2xl font-bold text-rose-400 mb-2 tracking-wide">
      Unsubscribe Failed!
    </h1>
    <p class="text-slate-300 text-sm mb-1">
      We couldn't process your request.
    </p>
    <p class="text-slate-400 text-xs mb-6">
      {{ message || 'The tracking link might be invalid or expired.' }}
    </p>

    <!-- Close Button -->
    <button (click)="onClose()" class="w-full py-3 px-6 bg-gradient-to-r from-rose-600 via-pink-600 to-purple-600 hover:from-rose-500 hover:to-purple-500 text-white font-semibold rounded-xl shadow-[0_0_20px_rgba(244,63,94,0.4)] hover:shadow-[0_0_25px_rgba(244,63,94,0.6)] border border-rose-400/30 transition-all duration-300 transform active:scale-95 text-sm tracking-wider">
      Close
    </button>
  </div>

</div>